import(/* webpackMode: "eager" */ "/root/enhanci-frontend/app/builder/[id]/page.tsx")